import ModuleService from "../../../services/ModuleService";
import _ from "lodash";

export default {
  namespaced: true,
  state: () => ({
    modulesList: [],
    getModulesList: [],
  }),
  getters: {
    modulesList: (state) => {
      return _.sortBy(state.modulesList, [
        function(o) {
          return o.status === "";
        },
      ]);
    },
  },
  mutations: {
    setModulesList: (state, list) => {
      state.modulesList = list;
    },
    setGetModulesList: (state, list) => {
      state.getModulesList = list;
    },
  },
  actions: {
    modulesList: ({ commit }) => {
      return new Promise((resolve, reject) => {
        ModuleService.modulesList()
          .then((res) => {
            commit("setModulesList", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getModulesList: ({ commit }) => {
      return new Promise((resolve, reject) => {
        ModuleService.getModulesList()
          .then((res) => {
            commit("setGetModulesList", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
